import COM from './Icon'

export default COM
